import React, { type ReactNode } from 'react';

import { cssMap } from '@atlaskit/css';
import { Bleed, Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	actionCardFooter: {
		justifyContent: 'end',
		flexDirection: 'row-reverse',
		borderTop: `${token('border.width')} solid ${token('color.border')}`,
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
	},
	actionCardFooterOuterMargin: {
		marginTop: token('space.150'),
		marginBottom: token('space.negative.150'),
	},
});

export const defaultFooter = (actionButtons: ReactNode): React.JSX.Element => (
	<Bleed inline="space.150" xcss={styles.actionCardFooterOuterMargin}>
		<Flex gap="space.050" alignItems="center" wrap="wrap" xcss={styles.actionCardFooter}>
			{actionButtons}
		</Flex>
	</Bleed>
);
